var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.inputModel)+" ")]},{"on":_vm.on,"attrs":_vm.attrs,"formatted":_vm.inputModel})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }